import { useTranslation } from 'react-i18next';

import { selectKpi } from '../constants/enum';

import type { TFunction } from 'react-i18next';

export interface CheckboxType {
  value?: number;
  label?: string;
  description?: string;
  optionGuideText?: string;
  category?: string;
  subCategory?: string;
}

export const article = (): CheckboxType[] => {
  const { t } = useTranslation();

  const articleList = [
    { label: t('article.label1'), value: 1 },
    { label: t('article.label2'), value: 2 },
    { label: t('article.label3'), value: 3 },
    { label: t('article.label4'), value: 4 },
    { label: t('article.label5'), value: 5 },
    { label: t('article.label6'), value: 6 },
    { label: t('article.label99'), value: 99 }
  ];

  return articleList;
};

export const proposal = (): CheckboxType[] => {
  const { t } = useTranslation();

  const proposalList = [
    { label: t('proposal.label1'), value: 1 },
    {
      description: t('proposal.label2Description'),
      label: t('proposal.label2'),
      value: 2
    },
    {
      description: t('proposal.label3Description'),
      label: t('proposal.label3'),
      value: 3
    },
    { label: t('proposal.label4'), value: 4 },
    { label: t('proposal.label5'), value: 5 },
    { label: t('proposal.label99'), value: 99 }
  ];

  return proposalList;
};

export const proposalSwitcher = (
  vals: number[] | null | undefined | boolean,
  t: TFunction
): CheckboxType[] => {
  const common = [
    { category: 'common', label: t('proposal.label21'), value: 21 },
    { label: t('proposal.label22'), value: 22 },
    { label: t('proposal.label23'), value: 23 },
    { label: t('proposal.label24'), value: 24 }
  ];

  const web = [
    {
      category: 'web',
      label: t('proposal.label1'),
      subCategory: 'article',
      value: 1
    },
    { label: t('proposal.label2'), value: 2 },
    { label: t('proposal.label3'), value: 3 },
    { label: t('proposal.label4'), value: 4 },
    { label: t('proposal.label5'), value: 5 },
    { label: t('proposal.label6'), value: 6 },
    { label: t('proposal.label7'), value: 7 },
    { label: t('proposal.label8'), value: 8 },
    { label: t('proposal.label11'), subCategory: 'banner', value: 11 },
    { label: t('proposal.label12'), value: 12 },
    { label: t('proposal.label13'), value: 13 },
    { label: t('proposal.label14'), value: 14 },
    { label: t('proposal.label15'), value: 15 }
  ];

  const ooh = [
    { category: 'ooh', label: t('proposal.label31'), value: 31 },
    { label: t('proposal.label32'), value: 32 },
    { label: t('proposal.label33'), value: 33 },
    { label: t('proposal.label34'), value: 34 },
    { label: t('proposal.label35'), value: 35 }
  ];

  const paper = [
    { category: 'paper', label: t('proposal.label44'), value: 44 },
    { label: t('proposal.label41'), value: 41 },
    { label: t('proposal.label42'), value: 42 },
    { label: t('proposal.label43'), value: 43 }
  ];

  const tvOrRadio = [
    { category: 'tvOrRadio', label: t('proposal.label51'), value: 51 },
    { label: t('proposal.label52'), value: 52 },
    { label: t('proposal.label53'), value: 53 },
    { label: t('proposal.label54'), value: 54 },
    { label: t('proposal.label55'), value: 55 },
    { label: t('proposal.label56'), value: 56 },
    { label: t('proposal.label57'), value: 57 }
  ];

  const other = [
    { category: 'otherMediaType', label: t('proposal.label99'), value: 99 }
  ];

  let proposalList: CheckboxType[] = common;
  if (vals === true) return proposalList.concat(other);
  if (Array.isArray(vals)) {
    const hasWeb = vals.includes(9);
    const hasOoh = vals.includes(10);
    const hasPaper = vals.includes(7) || vals.includes(8);
    const hasTvOrRadio = vals.includes(5) || vals.includes(6);
    if (hasWeb) {
      proposalList = proposalList.concat(web);
    }
    if (hasOoh) {
      proposalList = proposalList.concat(ooh);
    }
    if (hasPaper) {
      proposalList = proposalList.concat(paper);
    }
    if (hasTvOrRadio) {
      proposalList = proposalList.concat(tvOrRadio);
    }
    proposalList = proposalList.concat(other);
  } else if (typeof vals === 'number') {
    const isWeb = vals === 2 || vals === 3 || vals === 4;
    const isPaper = vals === 1;
    if (isWeb) {
      proposalList = proposalList.concat(web);
    } else if (isPaper) {
      proposalList = proposalList.concat(paper);
    }
    proposalList = proposalList.concat(other);
  }
  return proposalList;
};

export const attention = (): CheckboxType[] => {
  const { t } = useTranslation();

  const attentionList = [
    { label: t('attention.label1'), value: 1 },
    { label: t('attention.label2'), value: 2 },
    { label: t('attention.label3'), value: 3 },
    { label: t('attention.label4'), value: 4 },
    { label: t('attention.label5'), value: 5 },
    { label: t('attention.label6'), value: 6 },
    { label: t('attention.label7'), value: 7 },
    { label: t('attention.label8'), value: 8 },
    { label: t('attention.label9'), value: 9 },
    { label: t('attention.label10'), value: 10 },
    { label: t('attention.label99'), value: 99 }
  ];

  return attentionList;
};

export const kpi = (val: number | null | undefined): CheckboxType[] => {
  const { t } = useTranslation();
  let kpiList;
  if (val === selectKpi.interest) {
    kpiList = [
      { category: 'recommend', label: t('kpi.label1'), value: 1 },
      { category: 'recommend', label: t('kpi.label2'), value: 2 },
      { category: 'recommend', label: t('kpi.label9'), value: 9 },
      { category: 'other', label: t('kpi.label3'), value: 3 },
      { category: 'other', label: t('kpi.label4'), value: 4 },
      { category: 'other', label: t('kpi.label10'), value: 10 }
    ];
  } else if (val === selectKpi.understanding) {
    kpiList = [
      { category: 'recommend', label: t('kpi.label3'), value: 3 },
      { category: 'recommend', label: t('kpi.label4'), value: 4 },
      { category: 'recommend', label: t('kpi.label5'), value: 5 },
      { category: 'other', label: t('kpi.label6'), value: 6 },
      { category: 'other', label: t('kpi.label7'), value: 7 },
      { category: 'other', label: t('kpi.label8'), value: 8 },
      { category: 'other', label: t('kpi.label10'), value: 10 }
    ];
  } else if (val === selectKpi.promotion) {
    kpiList = [
      { category: 'recommend', label: t('kpi.label6'), value: 6 },
      { category: 'recommend', label: t('kpi.label8'), value: 8 },
      { category: 'recommend', label: t('kpi.label11'), value: 11 },
      { category: 'other', label: t('kpi.label1'), value: 1 },
      { category: 'other', label: t('kpi.label2'), value: 2 },
      { category: 'other', label: t('kpi.label9'), value: 9 },
      { category: 'other', label: t('kpi.label10'), value: 10 }
    ];
  } else if (val === selectKpi.acquisition) {
    kpiList = [
      { category: 'recommend', label: t('kpi.label8'), value: 8 },
      { category: 'recommend', label: t('kpi.label9'), value: 9 },
      { category: 'recommend', label: t('kpi.label12'), value: 12 },
      { category: 'other', label: t('kpi.label3'), value: 3 },
      { category: 'other', label: t('kpi.label5'), value: 5 },
      { category: 'other', label: t('kpi.label11'), value: 11 }
    ];
  } else if (val === selectKpi.other) {
    kpiList = [{ label: t('kpi.label10'), value: 10 }];
  } else {
    kpiList = [
      { label: t('kpi.label1'), value: 1 },
      { label: t('kpi.label2'), value: 2 },
      { label: t('kpi.label3'), value: 3 },
      { label: t('kpi.label4'), value: 4 },
      { label: t('kpi.label5'), value: 5 },
      { label: t('kpi.label6'), value: 6 },
      { label: t('kpi.label7'), value: 7 },
      { label: t('kpi.label8'), value: 8 },
      { label: t('kpi.label9'), value: 9 },
      { label: t('kpi.label11'), value: 11 },
      { label: t('kpi.label12'), value: 12 },
      { label: t('kpi.label10'), value: 10 }
    ];
  }
  return kpiList;
};

export const mainKpi = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.mainKpiOption.1'), value: 1 },
    { label: t('media.mainKpiOption.2'), value: 2 },
    { label: t('media.mainKpiOption.3'), value: 3 },
    { label: t('media.mainKpiOption.4'), value: 4 },
    { label: t('media.mainKpiOption.5'), value: 5 },
    { label: t('media.mainKpiOption.6'), value: 6 },
    { label: t('media.mainKpiOption.7'), value: 7 },
    { label: t('media.mainKpiOption.8'), value: 8 },
    { label: t('media.mainKpiOption.9'), value: 9 },
    { label: t('media.mainKpiOption.99'), value: 99 }
  ];
};

export const mediaType = (): CheckboxType[] => {
  const { t } = useTranslation();

  const mediaTypeList = [
    { label: t('mediaType.label5'), value: 5 },
    { label: t('mediaType.label6'), value: 6 },
    { label: t('mediaType.label7'), value: 7 },
    { label: t('mediaType.label8'), value: 8 },
    {
      description: t('mediaType.label9description'),
      label: t('mediaType.label9'),
      value: 9
    },
    {
      description: t('mediaType.label10description'),
      label: t('mediaType.label10'),
      value: 10
    }
  ];

  return mediaTypeList;
};

export const menu = (): CheckboxType[] => {
  const { t } = useTranslation();

  const menuList = [
    { label: t('menu.label6'), value: 6 },
    { label: t('menu.label7'), value: 7 },
    { label: t('menu.label8'), value: 8 },
    { label: t('menu.label9'), value: 9 },
    { label: t('menu.label10'), value: 10 },
    { label: t('menu.label11'), value: 11 },
    { label: t('menu.label12'), value: 12 },
    { label: t('menu.label13'), value: 13 },
    { label: t('menu.label99'), value: 99 }
  ];

  return menuList;
};
export const genreChoice = (): CheckboxType[] => {
  const { t } = useTranslation();

  const genreList = [
    { label: t('category.option1'), value: 1 },
    { label: t('category.option2'), value: 2 },
    { label: t('category.option3'), value: 3 },
    { label: t('category.option4'), value: 4 },
    { label: t('category.option5'), value: 5 },
    { label: t('category.option24'), value: 24 },
    { label: t('category.option25'), value: 25 },
    { label: t('category.option8'), value: 8 },
    { label: t('category.option9'), value: 9 },
    { label: t('category.option10'), value: 10 },
    { label: t('category.option11'), value: 11 },
    { label: t('category.option12'), value: 12 },
    { label: t('category.option13'), value: 13 },
    { label: t('category.option14'), value: 14 },
    { label: t('category.option15'), value: 15 },
    { label: t('category.option16'), value: 16 },
    { label: t('category.option17'), value: 17 },
    { label: t('category.option18'), value: 18 },
    { label: t('category.option19'), value: 19 },
    { label: t('category.option20'), value: 20 },
    { label: t('category.option21'), value: 21 },
    { label: t('category.option22'), value: 22 },
    {
      description: t('category.option23Desc'),
      label: t('category.option23'),
      value: 23
    },
    { label: t('category.option99'), value: 99 }
  ];

  return genreList;
};

export const funnel = (): CheckboxType[] => {
  const { t } = useTranslation();

  const funnelList = [
    { label: t('media.funnelOption.1'), value: 1 },
    { label: t('media.funnelOption.2'), value: 2 },
    { label: t('media.funnelOption.3'), value: 3 },
    { label: t('media.funnelOption.4'), value: 4 },
    { label: t('media.funnelOption.5'), value: 5 },
    { label: t('media.funnelOption.6'), value: 6 }
  ];

  return funnelList;
};

export const option = (): CheckboxType[] => {
  const { t } = useTranslation();

  const optionList = [
    {
      description: t('option.label1description'),
      label: t('option.label1'),
      optionGuideText: t('option.label1guideText'),
      value: 1
    },
    { label: t('option.label2'), value: 2 },
    {
      description: t('option.label3description'),
      label: t('option.label3'),
      value: 3
    },
    {
      description: t('option.label4description'),
      label: t('option.label4'),
      value: 4
    },
    {
      description: t('option.label5description'),
      label: t('option.label5'),
      value: 5
    }
  ];

  return optionList;
};

export const consult = (): CheckboxType[] => {
  const { t } = useTranslation();

  const consultList = [{ label: t('consult.label1'), value: 1 }];

  return consultList;
};

export const targetChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.targetOption.1'), value: 1 },
    { label: t('media.targetOption.2'), value: 2 },
    { label: t('media.targetOption.3'), value: 3 },
    { label: t('media.targetOption.4'), value: 4 },
    { label: t('media.targetOption.5'), value: 5 },
    { label: t('media.targetOption.6'), value: 6 },
    { label: t('media.targetOption.7'), value: 7 },
    { label: t('media.targetOption.8'), value: 8 },
    { label: t('media.targetOption.9'), value: 9 },
    { label: t('media.targetOption.10'), value: 10 },
    { label: t('media.targetOption.11'), value: 11 },
    { label: t('media.targetOption.12'), value: 12 },
    { label: t('media.targetOption.13'), value: 13 },
    { label: t('media.targetOption.14'), value: 14 }
  ];
};
export const productChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.adTypeOption.1'), value: 1 },
    { label: t('media.adTypeOption.2'), value: 2 },
    { label: t('media.adTypeOption.3'), value: 3 },
    { label: t('media.adTypeOption.6'), value: 6 },
    { label: t('media.adTypeOption.7'), value: 7 },
    { label: t('media.adTypeOption.4'), value: 4 },
    { label: t('media.adTypeOption.5'), value: 5 },
    { label: t('media.adTypeOption.8'), value: 8 },
    { label: t('media.adTypeOption.99'), value: 99 }
  ];
};

export const paymentChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.paymentOption.1'), value: 1 },
    { label: t('media.paymentOption.2'), value: 2 },
    { label: t('media.paymentOption.8'), value: 8 },
    { label: t('media.paymentOption.3'), value: 3 },
    { label: t('media.paymentOption.4'), value: 4 },
    { label: t('media.paymentOption.5'), value: 5 },
    { label: t('media.paymentOption.6'), value: 6 },
    { label: t('media.paymentOption.7'), value: 7 },
    { label: t('media.paymentOption.99'), value: 99 }
  ];
};

export const compensationChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.supplementaryOption.1'), value: 1 },
    { label: t('media.supplementaryOption.2'), value: 2 },
    { label: t('media.supplementaryOption.3'), value: 3 },
    { label: t('media.supplementaryOption.4'), value: 4 },
    { label: t('media.supplementaryOption.5'), value: 5 },
    { label: t('media.supplementaryOption.6'), value: 6 }
  ];
};

export const guaranteeChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('media.guaranteeFlgOption.1'), value: 1 },
    { label: t('media.guaranteeFlgOption.2'), value: 2 }
  ];
};

export const compensationOrderChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('message.order.compensation.1'), value: 1 },
    { label: t('message.order.compensation.2'), value: 2 },
    { label: t('message.order.compensation.3'), value: 3 },
    { label: t('message.order.compensation.4'), value: 4 },
    { label: t('message.order.compensation.5'), value: 5 },
    { label: t('message.order.compensation.6'), value: 6 }
  ];
};

export const compensationOrderLabel = (value: number): string => {
  const { t } = useTranslation();
  if (value === 1) {
    return t('message.order.compensation.1');
  } else if (value === 2) {
    return t('message.order.compensation.2');
  } else if (value === 3) {
    return t('message.order.compensation.3');
  } else if (value === 4) {
    return t('message.order.compensation.4');
  } else if (value === 5) {
    return t('message.order.compensation.5');
  }
  return '';
};

export const causeChoice = (): CheckboxType[] => {
  const { t } = useTranslation();
  return [
    { label: t('message.cause.1'), value: 1 },
    { label: t('message.cause.2'), value: 2 },
    { label: t('message.cause.3'), value: 3 },
    { label: t('message.cause.4'), value: 4 },
    { label: t('message.cause.5'), value: 5 },
    { label: t('message.cause.6'), value: 6 }
  ];
};
